import { useState } from 'react'
import './Contact.css'

const CONTACT_ENDPOINT = '/api/contact'

function ContactPage({ t }) {
  const [formValues, setFormValues] = useState({ name: '', email: '', message: '', website: '' })
  const [status, setStatus] = useState('idle')

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (status === 'sending') {
      return
    }

    setStatus('sending')
    try {
      const response = await fetch(CONTACT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formValues.name,
          email: formValues.email,
          message: formValues.message,
          website: formValues.website,
        }),
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok || !data.ok) {
        throw new Error(data.error || 'Request failed')
      }
      setFormValues({ name: '', email: '', message: '', website: '' })
      setStatus('success')
    } catch (error) {
      setStatus('error')
    }
  }

  return (
    <div className="page">
    <section id="contact" className="section">
      <div className="section-header">
        <h2>{t.contact.title}</h2>
        <p>{t.contact.lead}</p>
      </div>
      <div className="contact-stack">
        <h3 className="contact-subtitle">{t.contact.form.heading}</h3>
        <div className="contact-card">
          {t.contact.details.map((detail) => (
            <div className="contact-details" key={detail.title}>
              <span>{detail.title}</span>
              <div>{detail.body}</div>
            </div>
          ))}
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-field" aria-hidden="true" style={{ position: 'absolute', left: '-9999px', height: 0, overflow: 'hidden' }}>
            <label htmlFor="website">Website</label>
            <input
              id="website"
              name="website"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              value={formValues.website}
              onChange={handleChange}
            />
          </div>
          <div className="form-field">
            <label htmlFor="name">{t.contact.form.name}</label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder={t.contact.form.name}
              value={formValues.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label htmlFor="email">{t.contact.form.email}</label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder={t.contact.form.email}
              value={formValues.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-field">
            <label htmlFor="message">{t.contact.form.message}</label>
            <textarea
              id="message"
              name="message"
              placeholder={t.contact.form.message}
              value={formValues.message}
              onChange={handleChange}
              required
            />
          </div>
          <button className="btn primary" type="submit" disabled={status === 'sending'}>
            {status === 'sending' ? `${t.contact.form.submit}...` : t.contact.form.submit}
          </button>
          <p className="contact-status" role="status" aria-live="polite">
            {status === 'success' &&
              (t.contact.form.success || 'Message sent. We will get back to you soon.')}
            {status === 'error' &&
              (t.contact.form.error || 'Something went wrong. Please try again.')}
          </p>
        </form>
      </div>
    </section>
    </div>
  )
}

export default ContactPage
